import { BaseUrl, NewUpdatedBaseUrl } from "../../BaseUrl/BaseUrl";
import { getApiWithoutAuthorization, postApiWithAuthorization, postApiWithoutAuthorization } from "../ApiMethod/ApiMethod";


export const FAQ = async () => {
    const url = `${BaseUrl}/FAQ`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};
export const GetFAQListByService = async (ModuleID, SubModuleID) => {
    const url = `${BaseUrl}/GetFAQListByService?ModuleID=${ModuleID}&SubModuleID=${SubModuleID}`;
    const res = await getApiWithoutAuthorization(url);
    return res;
};

export const GetWebsiteFAQList = async (params) => {
    const url = `${NewUpdatedBaseUrl}/FAQ/GetWebsiteFAQList`;
    const res = await postApiWithAuthorization(url, params);
    return res;
};
